import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './Visuals/Colors.jsx';
import React, { useEffect, useState, Suspense } from 'react';
import { Provider } from 'react-redux';
import store from './Utils/store/store';
import PWAInstallPrompt from './Components/PWA/PWAInstallPrompt.jsx';

// Pages
import NavBar from './Routes/MainComponents/navigation/NavbarComponent.component.jsx';
import Footer from './Routes/MainComponents/footer/FooterComponent.component.jsx';
import CookieConstent from './Cookies/CookieBanner.component.jsx';
import BasePage from './Routes/MainComponents/base/BasePage.page.jsx';
import NotFound from './Routes/MainComponents/not-found/NotFoundPage.page.jsx';
import NewsletterModal from './Newsletter/NewsletterModal.component.jsx';
import ScrollToTop from './Helpers/scroll-to-top.jsx';

import { userRoutes } from './YodaRoutes/UserRoutes.jsx';
import { publicRoutes } from './YodaRoutes/PublicRoutes.jsx';
import { adminRoutes } from './YodaRoutes/AdminRoutes.jsx';
import { companyRoutes } from './YodaRoutes/CompanyRoutes.jsx';
import { courseRoutes } from './YodaRoutes/CourseRoutes.jsx';
import { subcontractorRoutes } from './YodaRoutes/SubcontractorRoutes.jsx';
import { IPRoutes } from './YodaRoutes/IPRoutes.jsx';

function App() {
  const [showEmailModal, setShowEmailModal] = useState(false);
  useEffect(() => {
    const isFirstVisit = localStorage.getItem('isFirstVisit');
    if (!isFirstVisit) {
      setShowEmailModal(true);
      localStorage.setItem('isFirstVisit', 'false');
    }
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <ScrollToTop />
            <div style={{ flex: '1 0 auto' }}>
              <NavBar />
              <CookieConstent />
              <PWAInstallPrompt />
              {showEmailModal && (
                <NewsletterModal setShowEmailModal={setShowEmailModal} />
              )}
              {/* Wrap all routes in Suspense */}
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  {/* <PublicRoutes /> */}
                  {/* Main public routes */}
                  <Route path="/" element={<BasePage />}>
                    {publicRoutes?.map(({ path, element, children }, idx) =>
                      children ? (
                        <Route key={path || idx} path={path} element={element}>
                          {children.map((child, cidx) => (
                            <Route
                              key={child.path || cidx}
                              index={child?.index}
                              path={child?.path}
                              element={child?.element}
                            />
                          ))}
                        </Route>
                      ) : (
                        <Route
                          key={path || idx}
                          path={path}
                          element={element}
                        />
                      )
                    )}
                  </Route>
                  {/* Admin Routes  */}
                  <Route path="/admin" element={<BasePage />}>
                    {adminRoutes?.map(({ path, element }, idx) => (
                      <Route key={path || idx} path={path} element={element} />
                    ))}
                  </Route>
                  {/* User Routes */}
                  <Route path="/user" element={<BasePage />}>
                    {userRoutes?.map(({ path, element }, idx) => (
                      <Route key={path || idx} path={path} element={element} />
                    ))}
                  </Route>

                  {/* Course Routes */}
                  <Route path="course" element={<BasePage />}>
                    {courseRoutes?.map(({ path, element }, idx) => (
                      <Route key={path || idx} path={path} element={element} />
                    ))}
                  </Route>

                  {/* Company Routes */}
                  <Route path="company" element={<BasePage />}>
                    {companyRoutes?.map(({ path, element }, idx) => (
                      <Route key={path || idx} path={path} element={element} />
                    ))}
                  </Route>

                  {/* Contractor Management Routes */}
                  <Route path="subcontractor" element={<BasePage />}>
                    {subcontractorRoutes?.map(({ path, element }, idx) => (
                      <Route key={path || idx} path={path} element={element} />
                    ))}
                  </Route>
                  {/* IP Routes */}
                  <Route path="inspectionpal" element={<BasePage />}>
                    {IPRoutes?.map(({ path, element }, idx) => (
                      <Route key={path || idx} path={path} element={element} />
                    ))}
                  </Route>
                  {/* <Route path='cart/:id' element={<BuyCourse />} /> */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
              <Footer />
            </div>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
